import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { scaleToSize } from '../_helpers';
import MediaService from '../../utils/DeviationMediaService';
import BlurredBackground from '../Full/_partials/BlurredBackground';

import hiddenStyles from './Hidden.scss';

export interface Props {
  deviation: PapiDeviation;
  icon: React.ReactNode;
  compact?: boolean;
  showBackground?: boolean;
  strict?: boolean;
  title?: string;
  className?: string;
  text?: React.ReactNode;
  width?: number;
  height?: number;
  button?: React.ReactNode;
  secondaryButton?: React.ReactNode;
}

const HiddenLayout: React.FC<Props> = ({
  icon,
  compact,
  showBackground = true,
  strict,
  title,
  text,
  className,
  button,
  secondaryButton,
  deviation,
  width,
  height,
}) => {
  const background = MediaService.getSmallestThumb(deviation);
  const fullImage = MediaService.getFullviewForSize(deviation, width, height);
  const childBoxSize = fullImage
    ? scaleToSize(fullImage, { width, height })
    : { width, height };

  return (
    <div
      style={{
        width,
        height,
      }}
      className={classnames(
        className,
        hiddenStyles['root'],
        compact && hiddenStyles['compact'],
        strict && hiddenStyles['strict']
      )}
    >
      <div style={childBoxSize} className={hiddenStyles['blocked-placeholder']}>
        {showBackground && background && (
          <BlurredBackground imageUrl={background.src} clientSideBlur />
        )}
        <div className={hiddenStyles['blocked-wrap']}>
          <div className={hiddenStyles['blocked-icon']}>{icon}</div>
          {title && (
            <div className={hiddenStyles['blocked-title']}>{title}</div>
          )}
          {Array.isArray(text)
            ? text.map(
                (node, idx) =>
                  node && (
                    <div
                      key={idx}
                      className={
                        title
                          ? hiddenStyles['blocked-text']
                          : hiddenStyles['blocked-text-large']
                      }
                    >
                      {node}
                    </div>
                  )
              )
            : text && (
                <div
                  className={
                    title
                      ? hiddenStyles['blocked-text']
                      : hiddenStyles['blocked-text-large']
                  }
                >
                  {text}
                </div>
              )}
          {button}
          {secondaryButton}
        </div>
      </div>
    </div>
  );
};
HiddenLayout.displayName = 'HiddenLayout';

export default HiddenLayout;
